import(/* webpackMode: "eager" */ "/srv/AltenB2B/node_modules/next/font/google/target.css?{\"path\":\"src/modules/common/components/footer/index.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/srv/AltenB2B/src/modules/common/components/nav/index.tsx");
